var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoorskinDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2045",
    "data-name": "Grupo 2045",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.571,
    height: 51.981,
    viewBox: "0 0 159.571 51.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1395",
    "data-name": "Ret\\xE2ngulo 1395",
    width: 159.571,
    height: 51.981,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2044",
    "data-name": "Grupo 2044",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1246",
    "data-name": "Caminho 1246",
    d: "M20.605,27.889c0-5.567-4.007-8.1-7.73-8.1-3.024,0-5.011,1.285-7.387,3.51V19.952L0,21.684l2.583,1.722V40.612L0,43.294H8.074L5.488,40.612V23.957c1.613-1.688,3.59-3.409,6.038-3.409,3.868,0,6.178,3.638,6.178,7.155V40.612l-2.586,2.682h8.073l-2.586-2.682Z",
    transform: "translate(0 -11.068)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1247",
    "data-name": "Caminho 1247",
    d: "M65.365,19.575a11.948,11.948,0,1,0,8.464,3.546,11.932,11.932,0,0,0-8.464-3.546m8.969,14.289a9.7,9.7,0,0,1-2.029,6.308,6.458,6.458,0,0,1-5.033,2.382c-2.63,0-5.353-1.523-7.469-4.178a15.155,15.155,0,0,1-3.314-9.257,9.7,9.7,0,0,1,2.028-6.308A6.46,6.46,0,0,1,63.55,20.43c2.631,0,5.353,1.523,7.469,4.177a15.154,15.154,0,0,1,3.314,9.257",
    transform: "translate(-29.951 -10.95)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1248",
    "data-name": "Caminho 1248",
    d: "M123.361,19.575a11.948,11.948,0,1,0,8.464,3.546,11.932,11.932,0,0,0-8.464-3.546m8.969,14.289a9.7,9.7,0,0,1-2.029,6.308,6.458,6.458,0,0,1-5.033,2.382c-2.63,0-5.353-1.523-7.469-4.178a15.155,15.155,0,0,1-3.314-9.257,9.7,9.7,0,0,1,2.028-6.308,6.46,6.46,0,0,1,5.034-2.381c2.631,0,5.353,1.523,7.469,4.177a15.154,15.154,0,0,1,3.314,9.257",
    transform: "translate(-62.394 -10.95)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1249",
    "data-name": "Caminho 1249",
    d: "M171.822,25.527V20.011l-5.484,1.732,2.583,1.722V40.718L166.334,43.4h8.074l-2.586-2.682V27.064a2.853,2.853,0,0,1,.909-2.12c1.212-1.172,3.635-1.787,6.663-1.686h.045l.724-3.284-.078.01c-4.537.567-7.519,1.706-8.264,5.541",
    transform: "translate(-93.048 -11.174)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1250",
    "data-name": "Caminho 1250",
    d: "M208.166,29.843q-.293-.124-.578-.247c-2.4-1.009-6.432-3.086-6.432-5.67,0-2.149,2.6-3.434,5.108-3.434a7.191,7.191,0,0,1,3.132.689l4.785,4.274.129.116-1.248-5.425-.01-.043h-6.789c-2.73,0-5.916,1.355-5.916,5.172,0,3.921,4.421,6.436,7.056,7.585l.228.107c2.972,1.392,7.043,3.3,7.043,5.984,0,2.355-2.576,4.131-5.992,4.131a12.016,12.016,0,0,1-3.971-.783l-4.97-4.367-.126-.111,1.246,5.607.009.043h7.813c3.967,0,6.846-2.351,6.846-5.591,0-4.908-4.083-6.643-7.363-8.037",
    transform: "translate(-111.665 -11.246)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1251",
    "data-name": "Caminho 1251",
    d: "M249.156,14.231c2.927-2.365,4.858-3.278,9.072-5.269l.222-.1h-6.624l1.324,2.129a25.685,25.685,0,0,0-7.216,5.793,13.2,13.2,0,0,0-2.373,3.925V0l-5.485,1.684,2.585,1.723V29.5l-2.585,2.728h8.071L243.561,29.5V23.239c0-3.052,2.51-6.005,3.372-6.927l6.694,13.849-1.921,2.066h7.229l-2.219-2.413Z",
    transform: "translate(-133.18)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1252",
    "data-name": "Caminho 1252",
    d: "M293.852,7.508A2.148,2.148,0,1,0,291.7,5.36a2.151,2.151,0,0,0,2.148,2.148",
    transform: "translate(-163.18 -1.797)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1253",
    "data-name": "Caminho 1253",
    d: "M293.75,20.058l-5.484,1.732,2.583,1.722V40.764l-2.586,2.682h8.074l-2.586-2.682Z",
    transform: "translate(-161.255 -11.22)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1254",
    "data-name": "Caminho 1254",
    d: "M327.238,27.7V40.612l-2.586,2.682h8.073l-2.586-2.682V27.889c0-5.567-4.007-8.1-7.73-8.1-3.024,0-5.011,1.285-7.387,3.51V19.952l-5.484,1.732,2.583,1.722V40.612l-2.586,2.682h8.074l-2.586-2.682V23.957c1.613-1.688,3.59-3.409,6.038-3.409,3.868,0,6.178,3.638,6.178,7.155",
    transform: "translate(-173.155 -11.068)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1255",
    "data-name": "Caminho 1255",
    d: "M108.1,104.928a2.415,2.415,0,0,1-1.624.552,2.341,2.341,0,0,1-2.324-2.536A2.44,2.44,0,0,1,106.5,100.3a1.773,1.773,0,0,1,1.867,1.836,4.172,4.172,0,0,1-.032.5h-3.353a2.135,2.135,0,0,0-.011.254c0,1.2.658,2.112,1.74,2.112a1.753,1.753,0,0,0,1.157-.445Zm-.53-2.695c0-.966-.435-1.507-1.125-1.507-.6,0-1.209.552-1.411,1.507Z",
    transform: "translate(-58.261 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1256",
    "data-name": "Caminho 1256",
    d: "M115.767,104.525a1.786,1.786,0,0,0,1.252.531c.711,0,1.2-.319,1.2-.849,0-.456-.36-.743-1.326-1.05s-1.421-.732-1.421-1.475c0-.721.626-1.379,1.772-1.379a3.065,3.065,0,0,1,1.528.382l-.255.594a1.953,1.953,0,0,0-1.337-.552c-.626,0-1.019.286-1.019.732s.308.7,1.231,1.019c1.114.382,1.517.785,1.517,1.485,0,.806-.626,1.517-1.888,1.517a3.552,3.552,0,0,1-1.528-.361Z",
    transform: "translate(-64.594 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1257",
    "data-name": "Caminho 1257",
    d: "M124.968,104.525a1.786,1.786,0,0,0,1.252.531c.711,0,1.2-.319,1.2-.849,0-.456-.36-.743-1.326-1.05s-1.421-.732-1.421-1.475c0-.721.626-1.379,1.772-1.379a3.065,3.065,0,0,1,1.528.382l-.255.594a1.953,1.953,0,0,0-1.337-.552c-.626,0-1.019.286-1.019.732s.308.7,1.231,1.019c1.114.382,1.517.785,1.517,1.485,0,.806-.626,1.517-1.888,1.517a3.553,3.553,0,0,1-1.528-.361Z",
    transform: "translate(-69.741 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1258",
    "data-name": "Caminho 1258",
    d: "M138.079,104.928a2.415,2.415,0,0,1-1.624.552,2.341,2.341,0,0,1-2.324-2.536,2.44,2.44,0,0,1,2.356-2.642,1.773,1.773,0,0,1,1.867,1.836,4.172,4.172,0,0,1-.032.5H134.97a2.138,2.138,0,0,0-.011.254c0,1.2.658,2.112,1.74,2.112a1.753,1.753,0,0,0,1.157-.445Zm-.53-2.695c0-.966-.435-1.507-1.125-1.507-.6,0-1.209.552-1.411,1.507Z",
    transform: "translate(-75.034 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1259",
    "data-name": "Caminho 1259",
    d: "M149.146,105.32v-3.151c0-.923-.34-1.252-1-1.252a2.064,2.064,0,0,0-1.368.8v3.608h-.764v-4.754l.764-.233v.8h.053a2.357,2.357,0,0,1,1.687-.827c.934,0,1.39.626,1.39,1.57v3.449Z",
    transform: "translate(-81.682 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1260",
    "data-name": "Caminho 1260",
    d: "M159.713,103a1.611,1.611,0,0,1-1.241.562c-.679,0-1.188-.392-1.188-1.485V98.993h-.8v-.446h.8V97.115l.764-.234v1.666h1.528v.446h-1.528v3.194c0,.594.254.859.615.859a1.133,1.133,0,0,0,.838-.435Z",
    transform: "translate(-87.539 -54.196)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1261",
    "data-name": "Caminho 1261",
    d: "M165.3,96.1a.553.553,0,1,1,.552.583.572.572,0,0,1-.552-.583m.17,6.536V97.886l.764-.233v4.987Z",
    transform: "translate(-92.467 -53.428)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1262",
    "data-name": "Caminho 1262",
    d: "M173.333,105.361v-.615h-.042a1.86,1.86,0,0,1-1.549.775c-1.209,0-1.91-1.04-1.91-2.44a2.406,2.406,0,0,1,2.377-2.663,2.75,2.75,0,0,1,1.178.265l.711-.308v4.987Zm0-4.138a1.673,1.673,0,0,0-1.072-.382c-.944,0-1.6.86-1.6,2.08s.52,2.016,1.432,2.016a1.521,1.521,0,0,0,1.241-.828Z",
    transform: "translate(-95.005 -56.15)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1263",
    "data-name": "Caminho 1263",
    d: "M182.63,102.3V95.14l.764-.234v7.4Z",
    transform: "translate(-102.164 -53.091)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1264",
    "data-name": "Caminho 1264",
    d: "M193.422,102.408V95.14l.764-.234v3.141h.042a1.882,1.882,0,0,1,1.549-.764c1.21,0,1.91,1.04,1.91,2.44a2.406,2.406,0,0,1-2.377,2.663,2.927,2.927,0,0,1-1.188-.265Zm.764-.827a1.738,1.738,0,0,0,1.072.382c.945,0,1.6-.86,1.6-2.08s-.509-2.016-1.432-2.016a1.523,1.523,0,0,0-1.241.828Z",
    transform: "translate(-108.201 -53.091)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1265",
    "data-name": "Caminho 1265",
    d: "M208.772,104.928a2.415,2.415,0,0,1-1.624.552,2.341,2.341,0,0,1-2.324-2.536,2.44,2.44,0,0,1,2.356-2.642,1.773,1.773,0,0,1,1.867,1.836,4.175,4.175,0,0,1-.032.5h-3.353a2.141,2.141,0,0,0-.011.254c0,1.2.658,2.112,1.74,2.112a1.753,1.753,0,0,0,1.157-.445Zm-.53-2.695c0-.966-.435-1.507-1.125-1.507-.6,0-1.209.552-1.411,1.507Z",
    transform: "translate(-114.58 -56.109)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1266",
    "data-name": "Caminho 1266",
    d: "M219.641,105.361v-.615H219.6a1.86,1.86,0,0,1-1.549.775c-1.209,0-1.91-1.04-1.91-2.44a2.406,2.406,0,0,1,2.377-2.663,2.75,2.75,0,0,1,1.178.265l.711-.308v4.987Zm0-4.138a1.673,1.673,0,0,0-1.072-.382c-.944,0-1.6.86-1.6,2.08s.52,2.016,1.432,2.016a1.521,1.521,0,0,0,1.241-.828Z",
    transform: "translate(-120.91 -56.15)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1267",
    "data-name": "Caminho 1267",
    d: "M231.983,105.522v-.668h-.053a2.341,2.341,0,0,1-1.687.827c-.934,0-1.39-.626-1.39-1.57v-3.449h.764v3.152c0,.923.35,1.252,1,1.252a2.042,2.042,0,0,0,1.369-.8v-3.608h.764v4.86Z",
    transform: "translate(-128.021 -56.311)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    "data-name": "Caminho 1268",
    d: "M242.782,103a1.611,1.611,0,0,1-1.241.562c-.679,0-1.188-.392-1.188-1.485V98.993h-.8v-.446h.8V97.115l.764-.234v1.666h1.528v.446h-1.528v3.194c0,.594.254.859.615.859a1.133,1.133,0,0,0,.838-.435Z",
    transform: "translate(-134.009 -54.196)",
    fill: "#5a5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    "data-name": "Caminho 1269",
    d: "M250.113,105.586l-2.133-4.923h.849l1.655,3.947,1.422-3.947h.5l-2.377,6.43c-.318.86-.732,1.2-1.326,1.2a1.7,1.7,0,0,1-.69-.148l.18-.786a.871.871,0,0,0,.637.393c.382,0,.594-.255.8-.828Z",
    transform: "translate(-138.721 -56.311)",
    fill: "#5a5551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoorskinDark);
export default __webpack_public_path__ + "static/media/noorskin-dark.3f8ffb5e37b525a23b4b6243ec059d84.svg";
export { ForwardRef as ReactComponent };